import siFetch from "api/fetch";

import handleParams from "api/handle-params";

const cashRecord = (params, init = null) =>
  siFetch(`/api/v1/asset/withdrawal_record${handleParams(params)}`, init);

export default cashRecord;
